"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyof = exports.CustomParsingError = exports.boolean = exports.map = exports.failure = exports.success = exports.nullable = exports.number = exports.string = exports.undefined = exports.literal = exports.discriminatedUnion = exports.union = exports.tuple = exports.omit = exports.pick = exports.partial = exports.required = exports.intersection = exports.optionalProperty = exports.property = exports.object = exports.array = exports.record = exports.unknown = exports.any = exports.noCheck = exports.createSchema = exports.tsEnum = exports.lazy = exports.t = void 0;
const array_1 = require("./array");
Object.defineProperty(exports, "array", { enumerable: true, get: function () { return array_1.array; } });
Object.defineProperty(exports, "tuple", { enumerable: true, get: function () { return array_1.tuple; } });
const object_1 = require("./object");
Object.defineProperty(exports, "object", { enumerable: true, get: function () { return object_1.object; } });
Object.defineProperty(exports, "required", { enumerable: true, get: function () { return object_1.required; } });
Object.defineProperty(exports, "intersection", { enumerable: true, get: function () { return object_1.intersection; } });
Object.defineProperty(exports, "partial", { enumerable: true, get: function () { return object_1.partial; } });
Object.defineProperty(exports, "property", { enumerable: true, get: function () { return object_1.property; } });
Object.defineProperty(exports, "optionalProperty", { enumerable: true, get: function () { return object_1.optionalProperty; } });
Object.defineProperty(exports, "pick", { enumerable: true, get: function () { return object_1.pick; } });
Object.defineProperty(exports, "omit", { enumerable: true, get: function () { return object_1.omit; } });
const result_1 = require("./result");
Object.defineProperty(exports, "success", { enumerable: true, get: function () { return result_1.success; } });
Object.defineProperty(exports, "failure", { enumerable: true, get: function () { return result_1.failure; } });
Object.defineProperty(exports, "map", { enumerable: true, get: function () { return result_1.map; } });
const parser_1 = require("./parser");
Object.defineProperty(exports, "CustomParsingError", { enumerable: true, get: function () { return parser_1.CustomParsingError; } });
Object.defineProperty(exports, "createSchema", { enumerable: true, get: function () { return parser_1.createSchema; } });
const union_1 = require("./union");
Object.defineProperty(exports, "discriminatedUnion", { enumerable: true, get: function () { return union_1.discriminatedUnion; } });
Object.defineProperty(exports, "union", { enumerable: true, get: function () { return union_1.union; } });
const lazy_1 = require("./lazy");
Object.defineProperty(exports, "lazy", { enumerable: true, get: function () { return lazy_1.lazy; } });
const noCheck_1 = require("./noCheck");
Object.defineProperty(exports, "noCheck", { enumerable: true, get: function () { return noCheck_1.noCheck; } });
const enum_1 = require("./enum");
Object.defineProperty(exports, "tsEnum", { enumerable: true, get: function () { return enum_1.tsEnum; } });
const record_1 = require("./record");
Object.defineProperty(exports, "record", { enumerable: true, get: function () { return record_1.record; } });
const primitives_1 = require("./primitives");
Object.defineProperty(exports, "literal", { enumerable: true, get: function () { return primitives_1.literal; } });
Object.defineProperty(exports, "undefined", { enumerable: true, get: function () { return primitives_1.undefined; } });
Object.defineProperty(exports, "string", { enumerable: true, get: function () { return primitives_1.string; } });
Object.defineProperty(exports, "number", { enumerable: true, get: function () { return primitives_1.number; } });
Object.defineProperty(exports, "nullable", { enumerable: true, get: function () { return primitives_1.nullable; } });
Object.defineProperty(exports, "any", { enumerable: true, get: function () { return primitives_1.any; } });
Object.defineProperty(exports, "unknown", { enumerable: true, get: function () { return primitives_1.unknown; } });
Object.defineProperty(exports, "boolean", { enumerable: true, get: function () { return primitives_1.boolean; } });
Object.defineProperty(exports, "keyof", { enumerable: true, get: function () { return primitives_1.keyof; } });
const t = {
    undefined: primitives_1.undefined,
    null: primitives_1.nullable,
    any: primitives_1.any,
    unknown: primitives_1.unknown,
    literal: primitives_1.literal,
    boolean: primitives_1.boolean,
    number: primitives_1.number,
    string: primitives_1.string,
    enum: enum_1.tsEnum,
    array: array_1.array,
    tuple: array_1.tuple,
    object: object_1.object,
    property: object_1.property,
    optionalProperty: object_1.optionalProperty,
    union: union_1.union,
    discriminatedUnion: union_1.discriminatedUnion,
    intersection: object_1.intersection,
    required: object_1.required,
    partial: object_1.partial,
    omit: object_1.omit,
    pick: object_1.pick,
    noCheck: noCheck_1.noCheck,
    lazy: lazy_1.lazy,
    record: record_1.record,
    keyof: primitives_1.keyof,
};
exports.t = t;
